import { render, staticRenderFns } from "./BdAside.vue?vue&type=template&id=8c4165cc&scoped=true&"
import script from "./BdAside.vue?vue&type=script&lang=js&"
export * from "./BdAside.vue?vue&type=script&lang=js&"
import style0 from "./BdAside.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BdAside.vue?vue&type=style&index=1&id=8c4165cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4165cc",
  null
  
)

export default component.exports